// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"89a2442b","453":"97678d0b","563":"d7edf5b8","658":"373825b2"}[chunkId] + ".chunk.js";
};